import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutBalanceData extends Layout {
    labelAvailableTractors1: Label;
    labelAvailableTractors2: Label;
    labelAvailableTractors3: Label;
    labelAvailableTractors4: Label;
    labelAvailableTractors5: Label;
    labelAvailableTractors6: Label;
    labelAvailableTractors7: Label;
    labelAvailableTractors: Label;
    labelBalance1: Label;
    labelBalance2: Label;
    labelBalance3: Label;
    labelBalance4: Label;
    labelBalance5: Label;
    labelBalance6: Label;
    labelBalance7: Label;
    labelBalance: Label;
    labelOut1: Label;
    labelOut2: Label;
    labelOut3: Label;
    labelOut4: Label;
    labelOut5: Label;
    labelOut6: Label;
    labelOut7: Label;
    labelOutMoves: Label;
    labelProjTractors1: Label;
    labelProjTractors2: Label;
    labelProjTractors3: Label;
    labelProjTractors4: Label;
    labelProjTractors5: Label;
    labelProjTractors6: Label;
    labelProjTractors7: Label;
    labelProjTractors: Label;
    panelAvailableTractors: Panel;
    panelBalance: Panel;
    panelOutMoves: Panel;
    panelProjTractors: Panel;
    panelZone: Panel;
    panelZoneInfo: Panel;
    sourceDispatchBalance: DataSource;
}
